const CONFIGURATION = {
    defaultTheme: 'pasa-dark',
    authorizedDomains: ['pasa.network'],
    apps: {
        mipasa: {
            enabled: false,
        },
        unbounded: {
            enabled: false,
        },
        papillon: {
            enabled: false,
        },
        crypto: {
            enabled: true,
            url: 'https://app.pasa.network',
        },
        dpasa: {
            enabled: false,
        },
        soikie: {
            enabled: false,
        },
    },
    oidc: {
        github: true,
        google: true,
        ethereum: true,
    },
    sentry: {
        enabled: true,
        dsn: 'https://a7607287ba53453897b34276cb967443@o952724.ingest.sentry.io/6753216',
        tunnel: '/tunnel',
        environment: 'Crypto',
    },
};
export default CONFIGURATION;
